module.exports = __webpack_public_path__ + "img/6.fe98eea1.png";